import './Uptime.scss';

import { InfoCircleOutlined } from '@ant-design/icons';
import { SETTINGS_DATA_SECURITY_COPY } from '@sonar-software/sonar-ts-constants';
import { SonarText } from '@ui/text';
import { useBoolean } from '@hooks';

import { Checkbox, Form, Radio, Row, Space, Tooltip } from 'antd';
import { Else, If, Then } from 'react-if';
import { MonitoringWindowType, UptimeMonitor } from '@sonar-software/sonar-core';
import React, { useState } from 'react';

export interface UptimeProps {
	editing: boolean
	fieldId?: number
	monitor: UptimeMonitor
}

export const Uptime: React.FC<UptimeProps> = ({
	editing,
	monitor,
	fieldId
}) => {
	const [ monitoringWindow, setMonitoringWindow ] = useState(monitor.monitorConfig.monitoringWindow);
	const [ enableOnWeekends, setEnableOnWeekends ] = useBoolean(monitor.monitorConfig.enableOnWeekends);

	return (
		<Space className='uptime-window'>
			<Row className='uptime-window-title'>
				<SonarText>
					{ SETTINGS_DATA_SECURITY_COPY.MONITOR_WINDOW }
				</SonarText>
				<Tooltip title={ SETTINGS_DATA_SECURITY_COPY.UPTIME_TOOLTIP }>
					<InfoCircleOutlined />
				</Tooltip>
			</Row>
			<If condition={ editing }>
				<Then>
					<Form.Item
						className='uptime-window-options'
						initialValue={ MonitoringWindowType.Daily }
						name={ fieldId === undefined ? [ 'monitorConfig', 'monitoringWindow' ] :
							[ fieldId, 'monitorConfig', 'monitoringWindow' ] }>
						<Radio.Group
							className='uptime-window-options-items'
							onChange={ (e) => setMonitoringWindow(e.target.value) }
							options={ Object.values(MonitoringWindowType) }
							size='small' />
					</Form.Item>
					<Form.Item
						className='uptime-weekdays-trigger'
						getValueFromEvent={ (e) => !e.target.checked }
						getValueProps={ (value) => ({ checked: !value }) }
						initialValue={ enableOnWeekends }
						name={ fieldId === undefined ? [ 'monitorConfig', 'enableOnWeekends' ] :
							[ fieldId, 'monitorConfig', 'enableOnWeekends' ] }
						valuePropName='checked'>
						<Checkbox onChange={ setEnableOnWeekends.toggle }>
							{ SETTINGS_DATA_SECURITY_COPY.UPTIME_WEEKDAYS_TRIGGER }
						</Checkbox>
					</Form.Item>
				</Then>
				<Else>
					<Row>
						<Radio
							checked
							className='uptime-window-options'>
							{ monitoringWindow }
						</Radio>
					</Row>
					<Row>
						<Checkbox
							checked={ !enableOnWeekends }
							className='uptime-weekdays-trigger'>
							{ SETTINGS_DATA_SECURITY_COPY.UPTIME_WEEKDAYS_TRIGGER }
						</Checkbox>
					</Row>
				</Else>
			</If>
		</Space>
	);
};
